import { memo } from 'react';
// @mui
import { 
  Stack,
  Typography,
} from '@mui/material';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Avatar from '../../components/Avatar';

// ----------------------------------------------------------------------

function CompanyAvatar({ companyId, width=24, height=24, nameVariant="body1", sx={} }) {
  const { company } = useCompany();
  const selectedCompany = company.find(c => c.id === parseInt(companyId)) || {};
  const { id, name } = selectedCompany;

  if (!id || id === NaN) return null;
  return (
    <Stack direction="row" spacing={1} sx={{ overflow: 'hidden', ...sx }}>
      <Avatar
        src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/bji_${id%4 + 1}.png`}
        alt={name}
        color={'default'}
        sx={{
          width: width,
          height: height,
        }}
      />
      <Typography variant={nameVariant} sx={{ textOverflow: 'ellipsis'}} noWrap>
        <b>{name}</b>
      </Typography>
    </Stack>
  )
}

export default memo(CompanyAvatar);
